const registration = (axios) => {
  return {

    /**
         * @method get
         * @api /api/registration//user/getTitles
         */
    getTitleData () {
      return axios.get('/user/getTitles')
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/registration/get_three
         */
    getThreeData () {
      return axios.get('/get_three')
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/registration/countries/get
         */
    getAllCountries () {
      return axios.get('/countries/get')
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/registration/company/get
         */
    getAllCompanies () {
      return axios.get('/company')
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/registration/user/check
         */
    checkUserData (params) {
      return axios.post('/user/check', params)
        .then((response) => response);
    },

    /**
             * @param params
             * @method post
             * @api /api/registration/user/insert_user
         */
    sendUserData (params) {
      return axios.post('/user/insert_user', params)
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/registration/language
         */
    getAllLanguages () {
      return axios.get('/language')
        .then((response) => response);
    },

  };
};

export default registration;
